import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  type ItemReceiptLineConstructor,
  ItemReceiptLine,
} from './ItemReceiptLine'

export const ItemReceiptLineConstructorFactory =
  Factory.Sync.makeFactory<ItemReceiptLineConstructor>({
    poIndex: Factory.each(() => faker.random.number()),
    itemName: Factory.each(() => faker.commerce.productName()),
    receiveQuantity: Factory.each(() => String(faker.random.number(20))),
  })

export const ItemReceiptLineFactory = EntityFactory(
  ItemReceiptLine,
  ItemReceiptLineConstructorFactory
)
